import {
  $convertFromMarkdownString,
  CHECK_LIST,
  TRANSFORMERS,
} from '@lexical/markdown';

import { useEffect, RefObject } from 'react';

import { MENTION_TRANSFORMER } from '@/components/editor/MentionPlugin/MentionPlugin';
import { TICKET_TRANSFORMER } from '@/components/editor/TicketPlugin/TicketPlugin';
import { PLACEHOLDER_TICKET_TRANSFORMER } from '@/components/editor/TicketPlugin/PlaceholderTicketNode';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';

interface MarkdownImportPluginProps {
  markdown: string;
  setValueRef?: RefObject<((value: string) => void) | null>;
}

export function MarkdownImportPlugin({
  markdown,
  setValueRef,
}: MarkdownImportPluginProps) {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (markdown) {
      editor.update(() => {
        $convertFromMarkdownString(markdown, [
          CHECK_LIST,
          ...TRANSFORMERS,
          MENTION_TRANSFORMER,
          TICKET_TRANSFORMER,
          PLACEHOLDER_TICKET_TRANSFORMER,
        ]);
      });
    }
  }, [editor]); // dont update on markdown change!

  // Register the setValue function for imperative access
  useEffect(() => {
    if (setValueRef) {
      setValueRef.current = (newValue: string) => {
        editor.update(() => {
          $convertFromMarkdownString(newValue, [
            CHECK_LIST,
            ...TRANSFORMERS,
            MENTION_TRANSFORMER,
            TICKET_TRANSFORMER,
            PLACEHOLDER_TICKET_TRANSFORMER,
          ]);
        });
      };
    }

    return () => {
      if (setValueRef) {
        setValueRef.current = null;
      }
    };
  }, [editor, setValueRef]);

  return null;
}
